import React, { useContext, useEffect } from "react";

import AppContext from "../../context/AppContext";
import { SIDER_TABS } from "../../utils/Constants";
import { AppStrings } from "../../utils/constants/AppStrings";
import { usePageTitle } from "../CommonComponents/Layout/PageTitleContext";
import BetLimits from "./BetLimits/BetLimits";

/**
 * Configuration entry point for Bet Settings under the Sportsbook sidebar.
 */
const ConfigurationBetLimits: React.FC = () => {
  usePageTitle(AppStrings.BET_SETTINGS_TITLE || AppStrings.BET_LIMITS);
  const { setActiveSidebarTab } = useContext(AppContext);

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.SPORTSBOOK, "BET_LIMITS");
  }, [setActiveSidebarTab]);

  return (
    <>
      <BetLimits />
    </>
  );
};

export default ConfigurationBetLimits;
